import { createContext, useContext } from "react";

import type { CollapsibleProps } from "./Collapsible.types";

export type CollapsibleContextValue = Pick<
  CollapsibleProps,
  "size" | "variant"
>;

export function makeCollapsibleContext({
  size = "md",
  variant = "ghost",
}: Partial<CollapsibleContextValue>): Required<CollapsibleContextValue> {
  return { size, variant };
}

export const CollapsibleContext = createContext<
  Required<CollapsibleContextValue>
>(makeCollapsibleContext({}));

export function useCollapsibleContext() {
  return useContext(CollapsibleContext);
}
